import { render } from "./App.vue?vue&type=template&id=18180672&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=18180672&lang=css"

import exportComponent from "/Users/fancyzhong/Desktop/code/hel-eco-of-github/hel-tpl-remote-vue3-comps-ts/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__